(function () {
  'use strict';

  function easeOutQuart(t) {
    return 1 - Math.pow(1 - t, 4);
  }

  function getTargetValue(value) {
    var clean = String(value || '').replace(',', '.').replace(/[^\d.-]/g, '');
    var number = parseFloat(clean);

    if (Number.isNaN(number)) return null;

    return number;
  }

  function formatValue(value, hasDecimal) {
    if (hasDecimal) {
      return value.toFixed(1).replace('.', ',');
    }

    return String(Math.round(value));
  }

  function animateCounter(el, target, duration, hasDecimal) {
    var start = null;
    var startVal = 0;

    function step(timestamp) {
      if (!start) start = timestamp;

      var elapsed = timestamp - start;
      var progress = Math.min(elapsed / duration, 1);
      var eased = easeOutQuart(progress);
      var current = startVal + (target - startVal) * eased;

      el.textContent = formatValue(current, hasDecimal);

      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent = formatValue(target, hasDecimal);
      }
    }

    requestAnimationFrame(step);
  }

  function initBlock(block) {
    if (block.dataset.wbstInitialized === 'true') return;

    block.dataset.wbstInitialized = 'true';

    var nums = block.querySelectorAll('[data-wbst-num]');
    if (!nums.length) return;

    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function runCounters() {
      nums.forEach(function (el) {
        var rawTarget = el.getAttribute('data-target');
        var target = getTargetValue(rawTarget);

        if (target === null) {
          el.textContent = rawTarget || '';
          return;
        }

        var hasDecimal = String(rawTarget || '').indexOf('.') > -1 || String(rawTarget || '').indexOf(',') > -1;

        if (prefersReduced) {
          el.textContent = formatValue(target, hasDecimal);
        } else {
          animateCounter(el, target, 1200, hasDecimal);
        }
      });
    }

    if (!('IntersectionObserver' in window)) {
      runCounters();
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        runCounters();
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.3 });

    observer.observe(block);
  }

  function init(container) {
    var blocks = container.querySelectorAll('[id^="wb-stats-"]');

    blocks.forEach(function (block) {
      initBlock(block);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();